// API
import { api } from '../configs/api/api';

// Models
import { ITransactions, ITransactionSettings } from '../interfaces/transactions.interfaces';

export const TransactionsService = {
  fetchTransactions: async (
    {
      offset,
      limit,
      show_calls,
      show_messages,
      show_audio_calls,
      show_conversations,
      date_from,
      date_to,
      order_type,
      order_by
    }: ITransactionSettings
  ): Promise<ITransactions | null> => {
    try {
      const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 10,
        show_calls: show_calls === false ? 0 : 1,
        show_messages: show_messages === false ? 0 : 1,
        show_audio_calls: show_audio_calls === false ? 0 : 1,
        show_conversations: show_conversations === false ? 0 : 1,
        ...(date_from && { date_from }),
        ...(date_to && { date_to }),
        ...(order_type && { order_type }),
        ...(order_by && { order_by }),
      };
      const axiosResponse = await api.get('/company/transactions', {
        params
      });
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  },
  refundTransaction: async (payment_id: number, refund_comment: string): Promise<{
    message?: string,
    error?: string,
    status: string
  }> => {
    try {
      const axiosResponse = await api.post('/users/request-refund', {
        payment_id,
        refund_comment
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message, status: 'error' };
      }
      return { ...res };
    }
  },
  getReceiptUrl: async (payment_id: number | string): Promise<{
    receipt_url?: string,
    message?: string,
    error?: string,
    status: string
  }> => {
    try {
      const axiosResponse = await api.get('/users/receipt-url', {
        params: { payment_id },
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message, status: 'error' };
      }
      return { ...res };
    }
  },
  getRecordedFile: async (transaction_id: number): Promise<{ archive_link?: string, error?: string }
  > => {
    try {
      const axiosResponse = await api.get('/company/transaction/recording', { params: { transaction_id } });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  refundCompanyTransaction: async (transaction_id: number, reason: string): Promise<{
    message?: string,
    error?: string,
    status: string
  }> => {
    try {
      const formData = new FormData();
      formData.append('transaction_id', String(transaction_id));
      formData.append('reason', reason);
      const axiosResponse = await api.post('/company/transactions/refund', formData);
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response?.status === 500) {
        return { error: res?.message, status: 'error' };
      }
      return { ...res };
    }
  },
}
